// Schemi auth condivisi tra backend (validation Fastify) e frontend (form).
// Single source of truth.
import { z } from 'zod';
import { PASSWORD_MIN_LENGTH } from '../constants.js';
export const LoginRequestSchema = z.object({
    email: z.string().email('Email non valida').max(255),
    password: z.string().min(1, 'Password obbligatoria').max(512),
});
// Sprint 5: il login risponde con discriminated union su `flow` per gestire
// 2FA: vedi schemas/settings.ts → LoginResponseSchema.
// Manteniamo questo helper per backward-compat (alcune parti del frontend
// possono ancora aspettarsi la shape "complete" senza inspezionare flow).
export const LegacyLoginUserShape = z.object({
    id: z.string().uuid(),
    email: z.string().email(),
    role: z.enum(['master', 'operator', 'viewer']),
});
export const PasswordPolicySchema = z
    .string()
    .min(PASSWORD_MIN_LENGTH, `Minimo ${PASSWORD_MIN_LENGTH} caratteri`)
    .regex(/[a-z]/, 'Almeno una minuscola')
    .regex(/[A-Z]/, 'Almeno una maiuscola')
    .regex(/[0-9]/, 'Almeno una cifra')
    .regex(/[^a-zA-Z0-9]/, 'Almeno un simbolo');
export const ApiErrorSchema = z.object({
    ok: z.literal(false),
    error: z.string(),
    code: z.string().optional(),
});
//# sourceMappingURL=auth.js.map